/**
 * Slider navigation (scroll mode) — global init.
 *
 * Handles `common-slider-navigation` snippet buttons with mode='scroll':
 *   - Click prev/next: scroll the target by 1 card width + gap
 *   - Toggle `disabled` at boundaries (CSS hides via opacity:0 / pointer-events:none)
 *   - Resize: re-evaluate disabled state via rAF coalesce
 *   - Dynamic content: window.LibertaSliderNav.scan() re-scans for new sliders
 *
 * Exposes:
 *   window.LibertaSliderNav.scan(root?: Element)
 *     - Initialize all `[data-scroll-target]` buttons under `root` (default: document)
 *     - Idempotent; existing initialized sliders are skipped via [data-arrows-attached]
 */
(function () {
  function findArrows(slider) {
    return {
      prev: document.querySelector(
        '[data-scroll-target="' + slider.id + '"][data-scroll-dir="-1"]'
      ),
      next: document.querySelector(
        '[data-scroll-target="' + slider.id + '"][data-scroll-dir="1"]'
      ),
    };
  }

  function updateArrows(slider) {
    var maxScroll = slider.scrollWidth - slider.clientWidth;
    var noOverflow = maxScroll <= 0;
    var arrows = slider._cachedArrows;
    if (!arrows) return;
    // boundary buffer 2px (browser zoom / inertia scroll で微小値が残るケース対応)
    if (arrows.prev) arrows.prev.disabled = noOverflow || slider.scrollLeft <= 2;
    if (arrows.next) arrows.next.disabled = noOverflow || slider.scrollLeft >= maxScroll - 2;
  }

  function initSlider(slider) {
    if (slider.dataset.arrowsAttached) return;
    slider.dataset.arrowsAttached = '1';
    slider._cachedArrows = findArrows(slider);
    slider.addEventListener(
      'scroll',
      function () {
        if (slider._ticking) return;
        slider._ticking = true;
        requestAnimationFrame(function () {
          updateArrows(slider);
          slider._ticking = false;
        });
      },
      { passive: true }
    );
    requestAnimationFrame(function () {
      updateArrows(slider);
    });
  }

  function scan(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-scroll-target]').forEach(function (btn) {
      var slider = document.getElementById(btn.dataset.scrollTarget);
      if (slider) initSlider(slider);
    });
  }

  // global resize / click handlers — flag-protected to avoid double-binding
  // when both this file and the legacy inline copy in home-layout.liquid load.
  if (!window.__commonSliderNavInit) {
    window.__commonSliderNavInit = true;

    var resizeFrame;
    window.addEventListener(
      'resize',
      function () {
        if (resizeFrame) cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(function () {
          document.querySelectorAll('[data-arrows-attached]').forEach(updateArrows);
        });
      },
      { passive: true }
    );

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-scroll-target]');
      if (!btn) return;
      var slider = document.getElementById(btn.dataset.scrollTarget);
      if (!slider) return;
      var card = slider.querySelector(':scope > div');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(slider).gap) || 0;
      var scrollAmount = card.offsetWidth + gap;
      var direction = parseInt(btn.dataset.scrollDir) || 1;
      slider.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
    });
  }

  function init() {
    scan(document);

    // 非同期挿入された rail (<product-recommendations> の innerHTML 差し替え後など)
    // を検出して scan() を再実行する。childList + subtree で全 DOM 変更を監視し、
    // [data-scroll-target] か [id^="slider-"] が追加されたタイミングで scan。
    // initSlider は idempotent (data-arrows-attached でガード) なので二重実行 OK。
    if (!window.__commonSliderNavObserver) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue; // Element のみ
            // 追加された要素自身 or その子孫に data-scroll-target / 対応 slider があれば scan
            if (
              (node.matches && node.matches('[data-scroll-target]')) ||
              (node.querySelector && node.querySelector('[data-scroll-target]'))
            ) {
              scan(document);
              return;
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      window.__commonSliderNavObserver = observer;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.LibertaSliderNav = {
    scan: scan,
    _initSlider: initSlider,
    _updateArrows: updateArrows,
  };
})();
